import React from 'react';
import { UpsertMissionMapProps } from './types';
import { FlightPlanMap } from './maps';

// Both create and edit (update-mission) use the single-page Flight Plan map; edit just
// arrives prefilled from the existing mission/order.
const UpsertMissionMap: React.FC<UpsertMissionMapProps> = () => <FlightPlanMap />;

export default UpsertMissionMap;
